import { useState } from 'react'
import { Allotment } from 'allotment'
import { Box, Container } from '@mui/material'

import { ExpertiseMeeting } from '@/core/models/expertise-meeting.model'
import { PatientConsultations } from '@/features/patient/patient-consultations'
import { MedicalActsSection } from '@/features/medical-acts/ui/MedicalActsSection'
import PatientDocuments from '@/pages/diagnostic/containers/PatientDocuments'
import ChimeProvider from '@/providers/ChimeProvider'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'

import { SidebarMenuItemId } from '../model/useSidebarMenuItems'
import { Attendees } from './Attendees'
import { Expertise } from './Expertise'
import { MeetingDisplay } from './MeetingDisplay'
import { PatientInfo } from './PatientInfo'

const ALLOTMENT_DEFAULT_SIZES = [40, 60]

export function MainContent({ expertiseMeeting, selectedSidebarMenuItem }: { expertiseMeeting: ExpertiseMeeting; selectedSidebarMenuItem: SidebarMenuItemId }) {
  const authUser = useAppSelector(selectAuthUser)
  const isCreator = authUser?._id === expertiseMeeting.createdBy

  const [allotmentSizes, setAllotmentSizes] = useState<number[]>(ALLOTMENT_DEFAULT_SIZES)

  return (
    <Box sx={{ flex: 1, height: '100%' }}>
      <Allotment defaultSizes={allotmentSizes} onChange={setAllotmentSizes}>
        <Allotment.Pane minSize={1}>
          <Container maxWidth="md" sx={{ height: '100%', overflowY: 'auto', py: 2 }}>
            {selectedSidebarMenuItem === 'patient-info' && (
              <>
                <PatientInfo patientId={expertiseMeeting.patient._id} />
                <PatientDocuments patientId={expertiseMeeting.patient._id} />
              </>
            )}
            {selectedSidebarMenuItem === 'patient-consultations' && <PatientConsultations patientId={expertiseMeeting.patient._id} />}
            {selectedSidebarMenuItem === 'medical-acts' && (
              <MedicalActsSection patientId={expertiseMeeting.patient._id} expertiseId={expertiseMeeting.expertise} />
            )}
            {selectedSidebarMenuItem === 'expertise' && <Expertise expertiseMeetingId={expertiseMeeting._id} />}
            {selectedSidebarMenuItem === 'attendees' && isCreator && <Attendees expertiseMeetingId={expertiseMeeting._id} />}
          </Container>
        </Allotment.Pane>
        <Allotment.Pane minSize={1}>
          <Box sx={{ height: '100%', display: 'flex', '& > div': { flex: 1 } }}>
            <ChimeProvider>
              <MeetingDisplay expertiseMeetingId={expertiseMeeting._id} />
            </ChimeProvider>
          </Box>
        </Allotment.Pane>
      </Allotment>
    </Box>
  )
}

function AllotmentLeftPane() {}
